import BaseModel from '@core/model';

export class IhtSector extends BaseModel {
    static entity = 'ihtSectors';

    static fields() {
        return {
            id: this.attr(null),
            name: this.string('')
        };
    }
}

export default IhtSector;
